import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { isArray as _isArray } from 'lodash';

import { ResponsiveImage } from 'sheets';
import TransparentJPEG from 'components/TransparentJPEG/TransparentJPEG';

import styles from './ValuePropStacked.css';

const cx = classNames.bind(styles);

const ValuePropStacked = (props) => {
  const contentMainStyles = classNames({
    [styles[`content-main`]]: props.children,
    [styles[`content-main--condensed`]]: !props.children,
    [props.contentClass]: props.contentClass,
  });
  const imageContainerStyles = cx(`image-container`, {
    'image-container--wide': props.imageWide,
  });

  const renderImage = () => {
    if (_isArray(props.imageConfig) && props.imageConfig[0].size) {
      return (
        <TransparentJPEG
          description={props.imageDescription}
          id={props.imageName}
          imageConfig={props.imageConfig}
        />
      );
    }

    return (
      <ResponsiveImage
        config={props.imageConfig}
        description={props.imageDescription}
        id={props.imageName}
      />
    );
  };

  const renderSecondaryContent = () => {
    if (!props.children) {
      return null;
    }

    return (
      <div className={styles[`content-secondary`]}>
        <div className={styles[`content`]}>
          {props.children}
        </div>
      </div>
    );
  };

  return (
    <section>
      <div className={contentMainStyles}>
        <div className={styles[`content`]}>
          <h2 className={styles[`heading`]}>{props.heading}</h2>
          <p className={styles[`body`]}>{props.body}</p>
          <div className={imageContainerStyles}>
            {renderImage()}
          </div>
        </div>
      </div>
      {renderSecondaryContent()}
    </section>
  );
};

ValuePropStacked.propTypes = {
  body: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
  ]),
  contentClass: PropTypes.string,
  heading: PropTypes.string.isRequired,
  imageConfig: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
  imageDescription: PropTypes.string.isRequired,
  imageName: PropTypes.string.isRequired,
};

export default ValuePropStacked;
